var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.88 29.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2.53px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.26 9.35 1.26 21.26 7.64 21.26 14.73 26.92 14.73 2.92 7.99 9.22 1.26 9.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.33,3.22c2.83,2.52,5.29,6.82,5.29,11.7s-2.38,9-5.11,11.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.16,5.92c2.36,2.08,3.86,5.23,3.86,8.76s-1.41,6.48-3.64,8.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.72,8.77c1.65,1.45,2.7,3.66,2.7,6.14s-.99,4.54-2.55,6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOn);
export default __webpack_public_path__ + "static/media/icon_sound_on.2cffc42b8e983b09b63c57222f720f2e.svg";
export { ForwardRef as ReactComponent };